import React, { useEffect, useRef, useState } from "react";
import { Button, Tooltip } from "antd";

import UserProfileImageList from "./components/UserProfileImageList";

import arrowRight from "../../assets/icons/arrow-right-2.svg";
import arrowUp from "../../assets/icons/arrow-down.png";
import arrowDown from "../../assets/icons/arrow-up.png";
import trash from "../../assets/icons/trash.png";
import { handleFilterTag } from "./utils";

// The `selected` prop is to check if the item is in the selected audience column or not, if yes instead of the add button the trash icon must be shown.
export default function AvailableAudienceItem({
  setAvailableAudiences,
  setSelectedIncludeOrExcludeAudiences,
  availableAudiences,
  includeOrExcludeAudiences,
  setSelectedAudiences,
  selectedAudiences,
  selected = false,
  scrollFromTop,
  audience,
}) {
  const [showSelectedFilters, setShowSelectedFilters] = useState(false);
  const [filtersPosition, setFiltersPosition] = useState({ top: 0, left: 0 });
  const filterRef = useRef(null);

  const audiencePatients = [
    { first_name: "Jim" },
    { first_name: "John" },
    { first_name: "Kevin" },
    { first_name: "Amanda" },
    { first_name: "Arman" },
    { first_name: "Mohammad" },
    { first_name: "Mohammad" },
    { first_name: "Mohammad" },
    { first_name: "Mohammad" },
    { first_name: "Mohammad" },
  ];

  // Updating the position of the filters while togeeling and scrolling
  useEffect(
    function () {
      if (showSelectedFilters && filterRef.current) {
        const rect = filterRef.current.getBoundingClientRect();

        // After teting multiple times, i found out that 45 and 360 are the proper values to position the element correctly.
        setFiltersPosition({ top: rect.top + 45, left: rect.left + rect.width - 360 });
      }
    },
    [showSelectedFilters, scrollFromTop]
  );

  // Adding new audiences to selected audience column
  function handleAddAudience(audience) {
    const newAvailabelAudiences = availableAudiences.filter((item) => item.id !== audience.id);
    setAvailableAudiences(newAvailabelAudiences);
    setSelectedIncludeOrExcludeAudiences((prevAudiences) => [...prevAudiences, audience])
    setSelectedAudiences((prevAudiences) => [...prevAudiences, audience]);
  }

  // Removing audiences from selected audiences column
  function handleRemoveAudience() {
    const newSelectedAudiences = selectedAudiences.filter((item) => item.id !== audience.id);
    setSelectedAudiences(newSelectedAudiences);
    const newIncludeOrExcludeAudiences = includeOrExcludeAudiences.filter((item) => item.id !== audience.id);
    setSelectedIncludeOrExcludeAudiences(newIncludeOrExcludeAudiences)
    setAvailableAudiences((prevAudiences) => [...prevAudiences, audience]);
  }

  return (
    <div style={{ padding: "10px 20px", border: "1px solid #E0DDF7", borderRadius: 10, backgroundColor: "white" }}>
      {/* Title with add button */}
      <div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 15 }}>
          <span style={{ color: "#6B43B5", fontSize: 16 }}>{audience.title}</span>

          {selected ? (
            <img src={trash} alt="trash" style={{ width: 20, cursor: "pointer" }} onClick={() => handleRemoveAudience(audience)} />
          ) : (
            <Button type="primary" style={{ padding: "10px 15px", fontSize: 14 }} onClick={() => handleAddAudience(audience)}>
              Add
              <img src={arrowRight} alt="rihgt-arrow" style={{ width: 17 }} />
            </Button>
          )}
        </div>

        {/* filters */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 15, position: "relative" }}>
          <span style={{ fontSize: 16 }}>Total Filters</span>

          <span style={{ padding: "3px 15px", color: "#6B43B5", backgroundColor: "#EEEDFA", borderRadius: 100 }} ref={filterRef}>
            {audience.criteria_count} Filters{" "}
            <img
              src={showSelectedFilters ? arrowDown : arrowUp}
              alt="arrow-up"
              style={{ width: 15, cursor: "pointer" }}
              onClick={() => setShowSelectedFilters((show) => !show)}
            />
          </span>
        </div>


        {/* Filter Container */}
        {showSelectedFilters && (
          <div
            style={{
              position: "fixed",
              top: `${filtersPosition.top}px`,
              left: `${filtersPosition.left}px`,
              borderRadius: 10,
              width: 370,
              maxWidth: 370,
              marginTop: "-15px",
              marginLeft: "-10px",
              padding: "10px",
              backgroundColor: "white",
              boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)",
              display: "flex",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap",
              zIndex: 100,
            }}
            className="custom-scroll"
          >
            {audience.criteria_details.map((tag) => <FilterTag key={tag} item={tag} /> )}
          </div>
        )}
      </div>

      {/* Patients */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: 16 }}>Total Patients</span>

        <div style={{ display: "flex", alignItems: "center" }}>
          {audiencePatients.slice(0, 6).map((patient, index) => (
            <UserProfileImageList key={index} index={index} text={patient.first_name.charAt(0)} totalPatients={audiencePatients.length} />
          ))}
        </div>
      </div>
    </div>
  );
}


export const FilterTag = ({ item }) => {
  const tagData = handleFilterTag(item);  
  
  return (
    <Tooltip title={tagData.info} placement="top" overlayStyle={{ maxWidth: 500 }} >
      <span
        style={{
          fontSize: 12,
          color: "#6B43B5",
          backgroundColor: "#EEEDFA",
          padding: "2px 10px",
          borderRadius: 100,
          textWrap: "nowrap",
          whiteSpace: "nowrap",
          cursor: "pointer",
        }}
      >
        {tagData.filter}
      </span>
    </Tooltip>
  );
};